import { Endpoint } from '@/types/api.type.ts';

export const holdingEndpoints: Endpoint[] = [
    {
        name: 'getHoldings',
        method: 'get',
        path: '/holdings',
    },
    {
        name: 'getHolding',
        method: 'get',
        path: '/holdings/:id',
    },
    {
        name: 'createHolding',
        method: 'post',
        path: '/holdings',
    },
    {
        name: 'updateHolding',
        method: 'patch',
        path: '/holdings/:id',
    },
    {
        name: 'activateHolding',
        method: 'patch',
        path: '/holdings/activate-holding/:id',
    },
    {
        name: 'deactivateHolding',
        method: 'patch',
        path: '/holdings/deactivate-holding/:id',
    },
    {
        name: 'getAllActiveHoldings',
        method: 'get',
        path: '/holdings/all-active',
    },
    {
        name: 'getHoldingDealers',
        method: 'get',
        path: '/holdings/:id/dealers',
    },
];
